module.exports = __webpack_public_path__ + "img/14.5efe3034.jpg";